









































































































import Vue from 'vue';
import VueAvatar from '../avatar.vue';
import VueUserName from '../user-name.vue';
import VueTimeago from '@/plugins/timeago';
import VueCommentForm from "./comment-form.vue";
import VueFlag from '../flags/flag.vue';
import { default as mixins } from '../mixins/user';
import { Prop, Mixins } from "vue-property-decorator";
import {mapActions, mapGetters, mapState} from "vuex";
import Component from "vue-class-component";
import { mixin as clickaway } from "vue-clickaway";
import store from "@/store";
import { Microblog } from "@/types/models";
import { MicroblogMixin } from "../mixins/microblog";
import declination from '@/libs/declination';

Vue.use(VueTimeago);

@Component({
  name: 'comment',
  mixins: [clickaway, mixins],
  store,
  components: {
    'vue-avatar': VueAvatar,
    'vue-username': VueUserName,
    'vue-comment-form': VueCommentForm,
    'vue-flag': VueFlag
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['isAuthorized'])
  },
  methods: {
    ...mapActions('microblogs', ['vote', 'loadVoters'])
  }
})
export default class VueComment extends Mixins(MicroblogMixin) {
  @Prop(Object)
  comment!: Microblog;

  reply() {
    this.$emit('reply', this.comment.user);
  }

  deleteItem() {
    this.delete('microblogs/deleteComment', this.comment);
  }

  restoreItem() {
    store.dispatch('microblogs/restoreComment', this.comment);
  }

  get anchor() {
    return `comment-${this.comment.id}`;
  }

  get highlight() {
    return '#' + this.anchor === window.location.hash;
  }

  get commentLabel() {
    return this.comment.votes + ' ' + declination(this.comment.votes, ['głos', 'głosy', 'głosów']);
  }

  get commentVoters() {
    return this.splice(this.comment.voters);
  }

  get flags() {
    return store.getters['flags/filter'](this.comment.id, 'Coyote\\Microblog');
  }
}
